/**
 * Os capítulos do guia de integração (#1782), um Markdown por capítulo em
 * `src/content/integration/<idioma>/NN-slug.md`, empacotados no build.
 *
 * O pt-BR é o original; o en-US e o es-ES são traduções com os mesmos arquivos, e a trava
 * `integration-guide.test.ts` garante que nenhum fique para trás. Idioma sem guia cai no en-US, o
 * mesmo `fallbackLng` do resto da tela.
 */

export interface GuideChapter {
  slug: string;
  title: string;
  body: string;
}

const FALLBACK_LOCALE = "en-US";

const SOURCES = import.meta.glob<string>("../../../content/integration/*/*.md", {
  query: "?raw",
  import: "default",
  eager: true,
});

const BY_LOCALE: Record<string, GuideChapter[]> = {};
for (const [path, text] of Object.entries(SOURCES)) {
  const match = path.match(/\/integration\/([^/]+)\/([^/]+)\.md$/);
  if (!match) continue;
  const [, locale, slug] = match;
  const title = text.match(/^# (.+)$/m)?.[1].trim() ?? slug;
  (BY_LOCALE[locale] ??= []).push({ slug, title, body: text });
}
for (const chapters of Object.values(BY_LOCALE)) {
  chapters.sort((a, b) => a.slug.localeCompare(b.slug));
}

export function guideChapters(locale: string): GuideChapter[] {
  return BY_LOCALE[locale] ?? BY_LOCALE[FALLBACK_LOCALE] ?? [];
}
